import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { clearItems } from '../../actions/adminAction';
import {
  clearClient,
  clearBuilding,
  clearFloor,
  clearRoom,
} from "../actions/adminAction";
import { useNavigate, useLocation } from "react-router-dom";

const Sidebar = ({
  users,
  buildings,
  floors,
  points,
  clients,
  configs,
  projects,
  deployments,
  devices,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const configModified = useSelector((state) => state.admin.configModified);
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    setSelected({
      users: location.pathname.includes("/admin/users"),
      clients: location.pathname.includes("/admin/clients"),
      buildings: location.pathname.includes("/admin/buildings"),
      floors: location.pathname.includes("/admin/floors"),
      configs: location.pathname.includes("/admin/configs"),
      projects: location.pathname.includes("/admin/projects"),
    });
  }, [location.pathname]);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState({
    users: location.pathname.includes("/admin/users"),
    buildings: location.pathname.includes("/admin/buildings"),
    floors: location.pathname.includes("/admin/floors"),
    clients: location.pathname.includes("/admin/clients"),
    configs: location.pathname.includes("/admin/configs"),
    projects: location.pathname.includes("/admin/projects"),
  });
  return (
    <div className=" shadow-lg h-100  sidebar position-fixed admin-list ">
      <div
        className="back"
        onClick={() => {
          setOpen(!open);
        }}
      >
        <div className="sidebar-icon text-center  py-3">
          {!open ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
              fill="currentColor"
            >
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              enableBackground="new 0 0 24 24"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
              fill="currentColor"
            >
              <path d="M0,0h24v24H0V0z" fill="none" />
              <path d="M3,18h13v-2H3V18z M3,13h10v-2H3V13z M3,6v2h13V6H3z M21,15.59L17.42,12L21,8.41L19.59,7l-5,5l5,5L21,15.59z" />
            </svg>
          )}
        </div>
      </div>

      {users && (
        <div
          className={`d-flex ${
            selected.users ? "sidebar-item-selected" : ""
          } sidebar-row cursor-pointer`}
          onClick={() => {
            if (configModified) {
              setSelected({
                users: false,
                buildings: false,
                clients: false,
                floors: false,
                configs: true,
              });
              alert("Your config is modified and has not been saved");
            } else {
              setSelected({
                users: true,
                buildings: false,
                clients: false,
                floors: false,
                configs: false,
              });
              navigate("/admin/users");
            }
            // clearItems();
          }}
        >
          <div className="sidebar-icon text-center  py-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24px"
              height="24px"
              fill="currentColor"
              className="bi bi-people"
              viewBox="0 0 16 16"
            >
              <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" />
            </svg>
          </div>
          <div className={`sidebar-description  ${!open ? "d-none" : " py-2"}`}>
            Users
          </div>
        </div>
      )}

      {clients && (
        <div
          className={`d-flex ${
            selected.clients ? "sidebar-item-selected" : ""
          } sidebar-row cursor-pointer`}
          onClick={() => {
            if (configModified) {
              setSelected({
                users: false,
                buildings: false,
                clients: false,
                floors: false,
                configs: true,
              });
              alert("Your config is modified and has not been saved");
            } else {
              setSelected({
                users: false,
                buildings: false,
                clients: true,
                floors: false,
                configs: false,
              });
              navigate("/admin/clients");
            }
            // clearItems();
          }}
        >
          <div className="sidebar-icon text-center  py-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              class="bi bi-asterisk"
              viewBox="0 0 16 16"
            >
              <path d="M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z" />
            </svg>
          </div>
          <div className={`sidebar-description  ${!open ? "d-none" : " py-2"}`}>
            Companies
          </div>
        </div>
      )}

      {buildings && (
        <div
          className={`d-flex ${
            selected.buildings ? "sidebar-item-selected" : ""
          } sidebar-row cursor-pointer`}
          onClick={() => {
            if (configModified) {
              setSelected({
                users: false,
                buildings: false,
                clients: false,
                floors: false,
                configs: true,
              });
              alert("Your config is modified and has not been saved");
            } else {
              setSelected({
                users: false,
                buildings: true,
                clients: false,
                floors: false,
                configs: false,
              });
              navigate("/admin/buildings");
            }
            // clearItems();
          }}
        >
          <div className="sidebar-icon text-center  py-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              class="bi bi-building"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022zM6 8.694 1 10.36V15h5V8.694zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15z"
              />
              <path d="M2 11h1v1H2v-1zm2 0h1v1H4v-1zm-2 2h1v1H2v-1zm2 0h1v1H4v-1zm4-4h1v1H8V9zm2 0h1v1h-1V9zm-2 2h1v1H8v-1zm2 0h1v1h-1v-1zm2-2h1v1h-1V9zm0 2h1v1h-1v-1zM8 7h1v1H8V7zm2 0h1v1h-1V7zm2 0h1v1h-1V7zM8 5h1v1H8V5zm2 0h1v1h-1V5zm2 0h1v1h-1V5zm0-2h1v1h-1V3z" />
            </svg>
          </div>
          <div className={`sidebar-description  ${!open ? "d-none" : " py-2"}`}>
            Buildings
          </div>
        </div>
      )}

      {floors && (
        <div
          className={`d-flex ${
            selected.floors ? "sidebar-item-selected" : ""
          } sidebar-row cursor-pointer`}
          onClick={() => {
            if (configModified) {
              setSelected({
                users: false,
                buildings: false,
                clients: false,
                floors: false,
                configs: true,
              });
              alert("Your config is modified and has not been saved");
            } else {
              setSelected({
                users: false,
                buildings: false,
                clients: false,
                floors: true,
                configs: false,
              });
              navigate("/admin/floors");
            }
            // clearItems();
          }}
        >
          <div className="sidebar-icon text-center  py-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              class="bi bi-columns"
              viewBox="0 0 16 16"
            >
              <path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V2zm8.5 0v8H15V2H8.5zm0 9v3H15v-3H8.5zm-1-9H1v3h6.5V2zM1 14h6.5V6H1v8z" />
            </svg>
          </div>
          <div className={`sidebar-description  ${!open ? "d-none" : " py-2"}`}>
            Floors
          </div>
        </div>
      )}

      {configs && (
        <div
          className={`d-flex ${
            selected.configs ? "sidebar-item-selected" : ""
          } sidebar-row cursor-pointer`}
          onClick={() => {
            setSelected({
              configs: true,
              buildings: false,
              users: false,
              floors: false,
            });
            navigate("/admin/configs");
            // clearItems();
            dispatch(clearClient());
            dispatch(clearBuilding());
            dispatch(clearFloor());
            dispatch(clearRoom());
          }}
        >
          <div className="sidebar-icon text-center  py-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              class="bi bi-bell"
              viewBox="0 0 16 16"
            >
              <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z" />
            </svg>
          </div>
          <div className={`sidebar-description  ${!open ? "d-none" : " py-2"}`}>
            Notifications
          </div>
        </div>
      )}
      {/* Project Configuration */}
      {projects && [1].includes(user.role_id) && (
        <div
          className={`d-flex ${
            selected.projects ? "sidebar-item-selected" : ""
          } sidebar-row cursor-pointer`}
          onClick={() => {
            if (configModified) {
              setSelected({
                users: false,
                buildings: false,
                clients: false,
                floors: false,
                configs: true,
              });
              alert("Your config is modified and has not been saved");
            } else {
              setSelected({
                users: false,
                buildings: false,
                clients: false,
                floors: false,
                configs: false,
                projects: true,
              });
              navigate("/admin/projects");
              // clearItems();
              dispatch(clearClient());
              dispatch(clearBuilding());
              dispatch(clearFloor());
              dispatch(clearRoom());
            }
          }}
        >
          <div className="sidebar-icon text-center  py-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              class="bi bi-file-earmark"
              viewBox="0 0 16 16"
            >
              <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z" />
            </svg>
          </div>
          <div className={`sidebar-description  ${!open ? "d-none" : " py-2"}`}>
            Projects
          </div>
        </div>
      )}

      {/* Deployment Configuration */}
      {/* {configs && (
        <div
          className={`d-flex ${
            selected.configs ? "sidebar-item-selected" : ""
          } sidebar-row cursor-pointer`}
          onClick={() => {
            setSelected({
              configs: true,
              buildings: false,
              users: false,
              floors: false,
            });
            navigate("/admin/configs");
            // clearItems();
          }}
        >
          <div className="sidebar-icon text-center  py-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              class="bi bi-rocket-takeoff"
              viewBox="0 0 16 16"
            >
              <path d="M9.752 6.193c.599.6 1.73.437 2.528-.362.798-.799.96-1.932.362-2.531-.599-.6-1.73-.438-2.528.361-.798.8-.96 1.933-.362 2.532Z" />
              <path d="M15.811 3.312c-.363 1.534-1.334 3.626-3.64 6.218l-.24 2.408a2.56 2.56 0 0 1-.732 1.526L8.817 15.85a.51.51 0 0 1-.867-.434l.27-1.899c.04-.28-.013-.593-.131-.956a9.42 9.42 0 0 0-.249-.657l-.082-.202c-.815-.197-1.578-.662-2.191-1.277-.614-.615-1.079-1.379-1.275-2.195l-.203-.083a9.556 9.556 0 0 0-.655-.248c-.363-.119-.675-.172-.955-.132l-1.896.27A.51.51 0 0 1 .15 7.17l2.382-2.386c.41-.41.947-.67 1.524-.734h.006l2.4-.238C9.005 1.55 11.087.582 12.623.208c.89-.217 1.59-.232 2.08-.188.244.023.435.06.57.093.067.017.12.033.16.045.184.06.279.13.351.295l.029.073a3.475 3.475 0 0 1 .157.721c.055.485.051 1.178-.159 2.065Zm-4.828 7.475.04-.04-.107 1.081a1.536 1.536 0 0 1-.44.913l-1.298 1.3.054-.38c.072-.506-.034-.993-.172-1.418a8.548 8.548 0 0 0-.164-.45c.738-.065 1.462-.38 2.087-1.006ZM5.205 5c-.625.626-.94 1.351-1.004 2.09a8.497 8.497 0 0 0-.45-.164c-.424-.138-.91-.244-1.416-.172l-.38.054 1.3-1.3c.245-.246.566-.401.91-.44l1.08-.107-.04.039Zm9.406-3.961c-.38-.034-.967-.027-1.746.163-1.558.38-3.917 1.496-6.937 4.521-.62.62-.799 1.34-.687 2.051.107.676.483 1.362 1.048 1.928.564.565 1.25.941 1.924 1.049.71.112 1.429-.067 2.048-.688 3.079-3.083 4.192-5.444 4.556-6.987.183-.771.18-1.345.138-1.713a2.835 2.835 0 0 0-.045-.283 3.078 3.078 0 0 0-.3-.041Z" />
              <path d="M7.009 12.139a7.632 7.632 0 0 1-1.804-1.352A7.568 7.568 0 0 1 3.794 8.86c-1.102.992-1.965 5.054-1.839 5.18.125.126 3.936-.896 5.054-1.902Z" />
            </svg>
          </div>
          <div className={`sidebar-description  ${!open ? "d-none" : " py-2"}`}>
            Deployments
          </div>
        </div>
      )} */}

      {/* Device Configuration */}
      {/* {configs && (
        <div
          className={`d-flex ${
            selected.configs ? "sidebar-item-selected" : ""
          } sidebar-row cursor-pointer`}
          onClick={() => {
            setSelected({
              configs: true,
              buildings: false,
              users: false,
              floors: false,
            });
            navigate("/admin/configs");
            // clearItems();
          }}
        >
          <div className="sidebar-icon text-center  py-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              class="bi bi-robot"
              viewBox="0 0 16 16"
            >
              <path d="M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.58 26.58 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.933.933 0 0 1-.765.935c-.845.147-2.34.346-4.235.346-1.895 0-3.39-.2-4.235-.346A.933.933 0 0 1 3 9.219V8.062Zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a24.767 24.767 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a25.286 25.286 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.182-.135Z" />
              <path d="M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2V1.866ZM14 7.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5Z" />
            </svg>
          </div>
          <div className={`sidebar-description  ${!open ? "d-none" : " py-2"}`}>
            Devices
          </div>
        </div>
      )} */}
    </div>
  );
};

export default Sidebar;
